export default {
  'menu.workbench': '工作台',
  'menu.more-blocks': '更多区块',
  'menu.home': '首页',
  'menu.admin': '管理页',
  'menu.admin.sub-page': '二级管理页',
  'menu.system': '系统管理',
  'menu.system.menu': '菜单管理',
  'menu.system.user': '用户管理',
  'menu.system.role': '角色管理',
  'menu.template': '模板示例',
  'menu.login': '登录',
  'menu.dashboard': 'Dashboard',
  'menu.dashboard.analysis': '分析页',
  'menu.dashboard.monitor': '监控页',
  'menu.dashboard.workplace': '工作台',
  'menu.exception.403': '403',
  'menu.exception.404': '404',
  'menu.exception.500': '500',
  'menu.form': '表单页',
  'menu.form.basic-form': '基础表单',
  'menu.form.step-form': '分步表单',
  'menu.form.step-form.info': '分步表单（填写转账信息）',
  'menu.form.step-form.confirm': '分步表单（确认转账信息）',
  'menu.form.step-form.result': '分步表单（完成）',
  'menu.form.advanced-form': '高级表单',
  'menu.list': '列表页',
  'menu.list.table-list': '查询表格',
  'menu.list.basic-list': '标准列表',
  'menu.list.card-list': '卡片列表',
  'menu.list.search-list': '搜索列表',
  'menu.list.search-list.articles': '搜索列表（文章）',
  'menu.list.search-list.projects': '搜索列表（项目）',
  'menu.list.search-list.applications': '搜索列表（应用）',
  'menu.profile': '详情页',
  'menu.profile.basic': '基础详情页',
  'menu.profile.advanced': '高级详情页',
  'menu.result': '结果页',
  'menu.result.success': '成功页',
  'menu.result.fail': '失败页',
  'menu.exception': '异常页',
  'menu.exception.not-permission': '403',
  'menu.exception.not-find': '404',
  'menu.exception.server-error': '500',
  'menu.exception.trigger': '触发错误',
  'menu.account': '个人页',
  'menu.account.center': '个人中心',
  'menu.account.workbench': '回到工作台',
  'menu.account.tenantManagement': '企业管理',
  'menu.account.trigger': '触发报错',
  'menu.account.logout': '退出登录',
  'menu.editor': '图形编辑器',
  'menu.editor.flow': '流程编辑器',
  'menu.editor.mind': '脑图编辑器',
  'menu.editor.koni': '拓扑编辑器',
  'menu.luole-admin.dashboard': '首页',
  'menu.luole-admin.ops': '招聘工作台',
  'menu.luole-admin.ops.workbench': '全部岗位',
  'menu.luole-admin.ops.jobs': '岗位',
  'menu.luole-admin.ops.jobs.all': '全部岗位',
  'menu.luole-admin.ops.jobs.followed': '我跟进过的',
  'menu.luole-admin.ops.jobs.viewed': '我浏览过的',
  'menu.luole-admin.ops.jobs.favorites': '我收藏的',
  'menu.luole-admin.ops.overview': '招聘总览',
  'menu.luole-admin.ops.enterprises': '企业',
  'menu.luole-admin.ops.enterprises.mine': '我负责的',
  'menu.luole-admin.ops.enterprises.team': '按部门分配',
  'menu.luole-admin.ops.enterprises.unassigned': '未分配',
  'menu.luole-admin.ops.enterprises.all': '全部企业',
  'menu.luole-admin.ops.talents': '人才跟进',
  'menu.luole-admin.ops.talents.favorites': '我的收藏',
  'menu.luole-admin.ops.talents.followed': '我跟进过的',
  'menu.luole-admin.ops.talents.viewed': '我浏览过的',
  'menu.luole-admin.ops.talents.detail': '人才详情',
  'menu.luole-admin.ops.assignments': '我负责的企业',
  'menu.luole-admin.ops.members': '角色权限',
  'menu.luole-admin.ops.luole-admin.ops.workbench': '全部岗位',
  'menu.luole-admin.ops.luole-admin.ops.overview': '招聘总览',
  'menu.luole-admin.ops.luole-admin.ops.enterprises': '企业',
  'menu.luole-admin.ops.luole-admin.ops.enterprises.mine': '我负责的',
  'menu.luole-admin.ops.luole-admin.ops.enterprises.team': '部门成员负责的',
  'menu.luole-admin.ops.luole-admin.ops.enterprises.unassigned': '未分配',
  'menu.luole-admin.ops.luole-admin.ops.enterprises.all': '全部企业',
  'menu.luole-admin.ops.enterprises.luole-admin.ops.enterprises.mine':
    '我负责的',
  'menu.luole-admin.ops.enterprises.luole-admin.ops.enterprises.team':
    '部门成员负责的',
  'menu.luole-admin.ops.enterprises.luole-admin.ops.enterprises.unassigned':
    '未分配',
  'menu.luole-admin.ops.enterprises.luole-admin.ops.enterprises.all':
    '全部企业',
  'menu.luole-admin.ops.luole-admin.ops.enterprises.luole-admin.ops.enterprises.mine':
    '我负责的',
  'menu.luole-admin.ops.luole-admin.ops.enterprises.luole-admin.ops.enterprises.team':
    '部门成员负责的',
  'menu.luole-admin.ops.luole-admin.ops.enterprises.luole-admin.ops.enterprises.unassigned':
    '未分配',
  'menu.luole-admin.ops.luole-admin.ops.enterprises.luole-admin.ops.enterprises.all':
    '全部企业',
  'menu.招聘工作台.企业.luole-admin.ops.enterprises.mine': '我负责的',
  'menu.招聘工作台.企业.luole-admin.ops.enterprises.team': '部门成员负责的',
  'menu.招聘工作台.企业.luole-admin.ops.enterprises.unassigned': '未分配',
  'menu.招聘工作台.企业.luole-admin.ops.enterprises.all': '全部企业',
  'menu.招聘工作台.企业.我负责的': '我负责的',
  'menu.招聘工作台.企业.部门成员负责的': '部门成员负责的',
  'menu.招聘工作台.企业.未分配': '未分配',
  'menu.招聘工作台.企业.全部企业': '全部企业',
  'menu.luole-admin.ops.luole-admin.ops.talents': '人才跟进',
  'menu.luole-admin.ops.talents.luole-admin.ops.talents.favorites': '我的收藏',
  'menu.luole-admin.ops.talents.luole-admin.ops.talents.followed': '我跟进过的',
  'menu.luole-admin.ops.talents.luole-admin.ops.talents.viewed': '我浏览过的',
  'menu.luole-admin.ops.talents.luole-admin.ops.talents.detail': '人才详情',
  'menu.luole-admin.ops.luole-admin.ops.talents.luole-admin.ops.talents.favorites':
    '我的收藏',
  'menu.luole-admin.ops.luole-admin.ops.talents.luole-admin.ops.talents.followed':
    '我跟进过的',
  'menu.luole-admin.ops.luole-admin.ops.talents.luole-admin.ops.talents.viewed':
    '我浏览过的',
  'menu.招聘工作台.人才跟进.我的收藏': '我的收藏',
  'menu.招聘工作台.人才跟进.我跟进过的': '我跟进过的',
  'menu.招聘工作台.人才跟进.我浏览过的': '我浏览过的',
  'menu.人才跟进.luole-admin.ops.talents.favorites': '我的收藏',
  'menu.人才跟进.luole-admin.ops.talents.followed': '我跟进过的',
  'menu.人才跟进.luole-admin.ops.talents.viewed': '我浏览过的',
  'menu.招聘工作台.人才跟进.luole-admin.ops.talents.favorites': '我的收藏',
  'menu.招聘工作台.人才跟进.luole-admin.ops.talents.followed': '我跟进过的',
  'menu.招聘工作台.人才跟进.luole-admin.ops.talents.viewed': '我浏览过的',
  'menu.招聘工作台.人才跟进.luole-admin.ops.talents.detail': '人才详情',
  'menu.人才跟进.luole-admin.ops.talents.detail': '人才详情',
  'menu.luole-admin.ops.luole-admin.ops.assignments': '我负责的企业',
  'menu.luole-admin.ops.luole-admin.ops.members': '我的收藏',
  'menu.luole-admin.architect-talent-ops': '人才端',
  'menu.luole-admin.architect-talent-ops.overview': '运营总览',
  'menu.人才端.luole-admin.member.management': '人才库',
  'menu.人才端.luole-admin.member.analytics': '人才画像',
  'menu.人才端.luole-admin.inviteManagement': '邀请管理',
  'menu.人才端.luole-admin.schoolShowcase': '高校风采',
  'menu.人才端.luole-admin.carousel.management': '轮播图',
  'menu.人才端.luole-admin.contentMarketing.management': '内容营销',
  'menu.人才端.luole-admin.resume.templates': '简历模版',
  'menu.人才端.luole-admin.architect-talent-ops.overview': '运营总览',
  'menu.企业端.luole-admin.recruitment-assistant-ops.jobs': '职位管理',
  'menu.企业端.luole-admin.enterprise.list': '企业库',
  'menu.企业端.luole-admin.enterprise.users': '企业用户',
  'menu.企业端.luole-admin.enterprise.verify': '企业认证',
  'menu.企业端.luole-admin.demoReservation': '预约演示',
  'menu.企业端.luole-admin.userFeedback': '用户反馈',
  'menu.企业端.luole-admin.forumRegistration': '论坛报名',
  'menu.企业端.luole-admin.jobFairRegistration': '招聘会报名',
  'menu.企业端.luole-admin.global.dictionary': '数据字典',
  'menu.企业端.luole-admin.registrationChannels': '注册渠道',
  'menu.luole-admin.architect-talent-ops.applications': '投递明细',
  'menu.luole-admin.architect-talent-ops.luole-admin.architect-talent-ops.overview':
    '运营总览',
  'menu.luole-admin.architect-talent-ops.luole-admin.architect-talent-ops.applications':
    '投递明细',
  'menu.luole-admin.architect-talent-ops.luole-admin.member.management':
    '人才库',
  'menu.luole-admin.architect-talent-ops.luole-admin.resume.templates':
    '简历模版',
  'menu.luole-admin.architect-talent-ops.luole-admin.member.analytics':
    '人才画像',
  'menu.luole-admin.architect-talent-ops.luole-admin.inviteManagement':
    '邀请管理',
  'menu.luole-admin.architect-talent-ops.luole-admin.schoolShowcase':
    '高校风采',
  'menu.luole-admin.architect-talent-ops.luole-admin.carousel.management':
    '轮播图',
  'menu.luole-admin.architect-talent-ops.luole-admin.contentMarketing.management':
    '内容营销',
  'menu.luole-admin.recruitment-assistant-ops': '企业端',
  'menu.luole-admin.recruitment-assistant-ops.jobs': '职位管理',
  'menu.luole-admin.recruitment-assistant-ops.luole-admin.recruitment-assistant-ops.jobs':
    '职位管理',
  'menu.luole-admin.recruitment-assistant-ops.luole-admin.recruitment-assistant-ops.overview':
    '运营总览',
  'menu.luole-admin.recruitment-assistant-ops.luole-admin.recruitment-assistant-ops.ai-job-monitor':
    'AI职位匹配监控',
  'menu.luole-admin.recruitment-assistant-ops.luole-admin.recruitment-assistant-ops.enterprise-portrait':
    '企业画像',
  'menu.luole-admin.recruitment-assistant-ops.luole-admin.recruitment-assistant-ops.enterprise-portrait.detail':
    '企业画像详情',
  'menu.luole-admin.campus-ops': '高校端',
  'menu.luole-admin.institution.verify': '高校认证审核',
  'menu.luole-admin.campus-ops.luole-admin.institution.verify': '高校认证审核',
  'menu.luole-admin.recruitment-assistant-ops.luole-admin.campus-ops': '高校端',
  'menu.luole-admin.recruitment-assistant-ops.luole-admin.enterprise.list':
    '企业库',
  'menu.luole-admin.recruitment-assistant-ops.luole-admin.enterprise.users':
    '企业用户',
  'menu.luole-admin.recruitment-assistant-ops.luole-admin.enterprise.verify':
    '企业认证',
  'menu.luole-admin.recruitment-assistant-ops.luole-admin.institution.verify':
    '高校认证审核',
  'menu.luole-admin.recruitment-assistant-ops.luole-admin.campus-ops.luole-admin.institution.verify':
    '高校认证审核',
  'menu.luole-admin.recruitment-assistant-ops.luole-admin.demoReservation':
    '企业预约演示',
  'menu.luole-admin.recruitment-assistant-ops.luole-admin.userFeedback':
    '用户反馈',
  'menu.luole-admin.recruitment-assistant-ops.luole-admin.registrationChannels':
    '渠道管理',
  'menu.luole-admin.recruitment': '招聘管理',
  'menu.luole-admin.activity': '活动管理',
  'menu.luole-admin.system': '系统设置',
  'menu.luole-admin.system.role-permissions': '角色权限',
  'menu.luole-admin.system.members': '成员管理',
  'menu.luole-admin.content': '内容配置',
  'menu.luole-admin.feedback': '反馈管理',
  'menu.luole-admin.analytics.recruitment': '招聘运营看板',
  'menu.luole-admin.job': '职位管理',
  'menu.luole-admin.job.management': '职位管理',
  'menu.luole-admin.member': '人才管理',
  'menu.luole-admin.member.management': '人才库',
  'menu.luole-admin.member.analytics': '人才画像',
  'menu.luole-admin.inviteManagement': '邀请管理',
  'menu.luole-admin.talent.create': '新建人才',
  'menu.luole-admin.enterprise': '企业管理',
  'menu.luole-admin.enterprise.list': '企业库',
  'menu.luole-admin.enterprise.users': '企业用户',
  'menu.luole-admin.enterprise.verify': '企业认证',
  'menu.luole-admin.enterprise.create': '新建企业',
  'menu.luole-admin.enterprise.edit': '编辑企业',
  'menu.luole-admin.resume.templates': '简历模版',
  'menu.luole-admin.application': '申请管理',
  'menu.luole-admin.talent.recommendation': '人才推荐',
  'menu.luole-admin.job-fair': '招聘会',
  'menu.luole-admin.job-fair.management': '招聘会',
  'menu.luole-admin.job-fair.detail': '招聘会详情',
  'menu.luole-admin.job-fair.create': '创建招聘会',
  'menu.luole-admin.job-fair.edit': '编辑招聘会',
  'menu.luole-admin.job-fair.info.add': '添加信息',
  'menu.luole-admin.job-fair.info.edit': '编辑信息',
  'menu.luole-admin.schoolShowcase': '高校风采',
  'menu.luole-admin.schoolShowcase.create': '新建高校风采',
  'menu.luole-admin.schoolShowcase.edit': '编辑高校风采',
  'menu.luole-admin.global': '全局配置',
  'menu.luole-admin.global.dictionary': '职位类别',
  'menu.luole-admin.carousel': '轮播图',
  'menu.luole-admin.carousel.management': '轮播图',
  'menu.luole-admin.carousel.create': '新建轮播图',
  'menu.luole-admin.carousel.edit': '编辑轮播图',
  'menu.luole-admin.contentMarketing.management': '内容营销',
  'menu.luole-admin.contentMarketing.create': '新建内容',
  'menu.luole-admin.contentMarketing.edit': '编辑内容',
  'menu.luole-admin.task.management': '任务管理',
  'menu.luole-admin.recruitment-assistant-ops.luole-admin.forumRegistration':
    '论坛报名',
  'menu.luole-admin.recruitment-assistant-ops.luole-admin.jobFairRegistration':
    '招聘会报名',
  'menu.luole-admin.recruitment-assistant-ops.luole-admin.global.dictionary':
    '职位类别',
  'menu.luole-admin.forumRegistration': '论坛报名',
  'menu.luole-admin.forumRegistration.detail': '论坛报名详情',
  'menu.luole-admin.jobFairRegistration': '招聘会报名',
  'menu.luole-admin.jobFairRegistration.detail': '招聘会报名详情',
  'menu.luole-admin.demoReservation': '企业预约演示',
  'menu.luole-admin.userFeedback': '用户反馈',
  'menu.luole-admin.registrationChannels': '渠道管理',
  'menu.luole-admin.userFeedback.detail': '反馈详情',
};
